import { useMutation } from '@tanstack/react-query';
import type { AgentApiProfitsShow } from '@/types/serializers';

export default function useCompanyDecline() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (id: number) => {
      const res = await fetch(`/agent/api/profits/${id}/company_decline`, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({}),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.errors?.join(', ') || '企業NG処理に失敗しました');
      }
      const data: AgentApiProfitsShow = await res.json();
      return data;
    },
  });
}
